import React from 'react';

import '../styles.scss';

interface IProps {
  searchAction: Function;
  searchTerm: string;
}

export const DEBOUNCE_TIMEOUT = 500;

const SearchInput = (props: IProps) => {
  const { searchAction, searchTerm } = props;

  const handleQueryStringChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    searchAction(e.target.value);
  };

  return (
    <div styleName="input-wrapper">
      <input
        data-testid="search-input"
        type="text"
        placeholder="Search First Name, Last Name"
        value={searchTerm}
        onChange={(e) => handleQueryStringChange(e)}
      />
      <div />
    </div>
  );
};

export default SearchInput;
